















import VueOptions from '@utils/VueOptions'

settings = 
  name: 'VendorListingResourceListItem'
  
  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

export default VueOptions.vue settings
